import { Page } from "modules/Page";

import "./glossary-listings-page.scss";

export class GlossaryListingsPage extends Page<typeof GlossaryListingsPage> {
    public static readonly className = "js-glossary-listings-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.initLetterFilter();
    }

    public initLetterFilter(): void {
        const glossaryList: NodeListOf<HTMLLIElement> = this.rootElement.querySelectorAll(".glossary-list > li");
        const filterLetters: NodeListOf<HTMLInputElement> = this.rootElement.querySelectorAll(".letter-filter input");
        const clearFilter: HTMLElement | null = this.rootElement.querySelector(".clear-filter");
        const noGlossarys: HTMLElement | null = this.rootElement.querySelector(".glossary-list__empty");
        const loadMoreButton: HTMLElement | null = this.rootElement.querySelector(".load-more-button");
        const searchInput: HTMLInputElement | null = this.rootElement.querySelector(".srchTxt");
        const enableUmlautCharacters: HTMLElement | null = this.rootElement.querySelector(".EnableUmlautCharacters");

        const showOrHideNoGlossarys = (visibleItems: HTMLElement[]): void => {
            if (visibleItems.length === 0) {
                noGlossarys?.classList.add("show");
            } else {
                noGlossarys?.classList.remove("show");
            }
        };

        const filterGlossaryItems = (predicate: (text: string) => boolean): void => {
            const matchedItems: HTMLElement[] = [];

            // Normalizes and strips diacritics from Unicode characters (like �, �, �)
            const normalizeText = (text: string): string =>
                text
                    .normalize("NFD")                  // Split letters from accents
                    .replace(/[\u0300-\u036f]/g, "")   // Remove all combining marks

            glossaryList.forEach((li) => {
                const rawData = li.getAttribute("data-item")?.toLowerCase() || "";
                let data = ""

                if (enableUmlautCharacters?.innerHTML === "False") {
                    data = normalizeText(rawData);
                } else {
                    data = rawData;
                }

                if (predicate(data)) {
                    li.classList.remove("hide");
                    matchedItems.push(li);
                } else {
                    li.classList.add("hide");
                }
            });

            showOrHideNoGlossarys(matchedItems);
        };

        // Search input event
        searchInput?.addEventListener("input", (e: Event) => {
            const target = e.target as HTMLInputElement;
            const input = target.value.toLowerCase();
            loadMoreButton?.classList.remove("show");

            filterGlossaryItems((text) => text.includes(input));

            const activeFilter = this.rootElement.querySelector<HTMLInputElement>('input[name="letter"]:checked');
            if (activeFilter) {
                activeFilter.checked = false;
            }
        });

        // Letter filter click
        filterLetters.forEach((letterInput) => {
            letterInput.addEventListener("click", () => {
                loadMoreButton?.classList.remove("show");
                const letter = letterInput.id.toLowerCase();
                filterGlossaryItems((text) => text.startsWith(letter));
            });
        });

        // Clear filter click
        clearFilter?.addEventListener("click", () => {
            glossaryList.forEach((li) => li.classList.remove("hide"));

            const activeFilter = this.rootElement.querySelector<HTMLInputElement>('input[name="letter"]:checked');
            if (activeFilter) {
                activeFilter.checked = false;
            }

            noGlossarys?.classList.remove("show");
        });

        // Load more
        if (glossaryList.length > 13) {
            loadMoreButton?.classList.add("show");
        }

        loadMoreButton?.addEventListener("click", () => {
            loadMoreButton?.classList.remove("show");
            glossaryList.forEach((li) => { 
                li.classList.remove("hide");
            });
        });
    }
}
